import { OptionDefinition } from 'src/common/types/OptionDefinition';

export const FREQUENCY_OPTIONS: Record<string, OptionDefinition[]> = {
  Actuals: [{ label: 'MONTHLY', value: 'MONTHLY' }],
  Planning: [{ label: 'DAILY', value: 'DAILY' }],
};
